import React from 'react'
import './App.css'
import Header from './components/Header'
import NavBar from './containers/NavBar'

function App() {
    return (
        <div className="App">
            <Header />
            <hr />
            <NavBar />
            <br />
        </div>
    )
}

export default App
